import type { LoginSDK, Channels } from './types';

let loginSDKPromise: Promise<LoginSDK>

/**
 * 获取 Eureka 登录 SDK
 * 动态加载远程登录 SDK 脚本
 */
export function getEurekaLoginSDK(): Promise<LoginSDK> {
    loginSDKPromise ??= import(`${import.meta.env.VITE_EUREKA_URI}/login/login.sdk.es.no-cache.js`)
    return loginSDKPromise
}

export async function openLoginDialog(options?: {
    channels?: Channels
    onSuccess?: () => Promise<void>
    onError?: (error: any) => void
}) {
    try {
        const { openLoginDialog } = await getEurekaLoginSDK();
        await openLoginDialog({
            channels: {
                from: 'eureka',
                ...options?.channels,
            },
        });

        if (options?.onSuccess) {
            await options.onSuccess();
        } else {
            // 登录成功后刷新页面，获取最新登录状态
            window.location.reload();
        }
    } catch (error: any) {
        if (options?.onError) {
            options.onError(error);
        } else {
            if (error.type === 'close') {
                console.log('用户关闭登录框');
            } else if (error.type === 'failed') {
                console.error('登录失败:', error.message);
            }
        }
    }
}
